import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { AdjacentType, Milliseconds } from '@iotv/iotv-v3-types';
import { TabPanel } from '@mui/lab';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { getNiceDate } from '@iotv/datamodel-core';
import AppDao from '../../../../data/AppDao';
import { useObjectByTypeAndName } from '../../../../hooks/useObjectByTypeAndName';
import config from '@iotv/config';
import { DataGrid } from '@mui/x-data-grid';
const debug = process.env.REACT_APP_DEBUG && false;
const dyn = config.aws.dynamoDB;
export const AWOLIncidents = ({ value }) => {
    const [appContext] = useContext(AppMainViewContext);
    const { contextCustomer } = appContext;
    const initialType = 'Gateway';
    const { components: { entitySelector, objectTypeSelector }, state: { currentEntity: [currentEntity, setCurrentEntity], objectTypeState, }, } = useObjectByTypeAndName({
        contextObject: undefined,
        adjacencyType: AdjacentType.SUBJECT,
        currentObject: undefined,
        currentObjectTypeId: initialType,
        validTypeIds: ['Device', 'Gateway'],
    });
    const [awolIncidents, setAwolIncidents] = useState([]);
    const getIncidents = async (awolEntity) => {
        const res = await AppDao.getMainTableQueryResultsWithReturn({
            TableName: dyn.tableName,
            IndexName: dyn.tsiName,
            ExpressionAttributeNames: {
                '#p': dyn.pKey,
                '#t': dyn.tsiSortKey,
                '#s': dyn.sKey,
            },
            ExpressionAttributeValues: {
                ':p': awolEntity.sk,
                ':t': Date.now() - 90 * Milliseconds.DAY,
                ':s': 'Incident',
            },
            KeyConditionExpression: '#p = :p and #t > :t',
            FilterExpression: 'begins_with(#s, :s)',
            ScanIndexForward: false,
        });
        if (res.data) {
            console.log('Incident res', res.data);
            setAwolIncidents(res.data.Items);
        }
        else {
            console.log('incident query', res);
        }
    };
    useEffect(() => {
        if (currentEntity) {
            getIncidents(currentEntity);
        }
    }, [currentEntity]);
    return (_jsxs(TabPanel, { value, children: [_jsx(Typography, { variant: 'h6', children: "AWOL Incidents" }), objectTypeSelector, entitySelector, _jsx("div", { height: '50vh', children: _jsx(DataGrid, { sx: { height: '50vh' },
                    columns: [
                        { field: 'timestamp', width: 200, valueFormatter: (value, row, column, apiRef) => getNiceDate(value) },
                        ...['name', '_status'].map((c) => ({ field: c, width: 250 })),
                    ],
                    rows: [...awolIncidents] }) }), _jsx(Typography, { children: ` Current entitty: ${currentEntity ? currentEntity.name : 'Nothing '}` })] }, 'batchPut'));
};
